import intlMessageDE from '../i18n/locales/de.json';
import intlMessageEN from '../i18n/locales/en.json';
import intlMessageES from '../i18n/locales/es.json';
import intlMessageFR from '../i18n/locales/fr.json';
import intlMessageHI from '../i18n/locales/hi.json';
import intlMessageIT from '../i18n/locales/it.json';
import intlMessageJP from '../i18n/locales/ja.json';
import intlMessagePT from '../i18n/locales/pt.json';
import intlMessageRO from '../i18n/locales/ro.json';
import intlMessageAR from '../i18n/locales/ar.json';
import intlMessageTR from '../i18n/locales/tr.json';
import intlMessageNL from '../i18n/locales/nl.json';
import {DataHandler} from "@amzn/dolphin-web-framework";
import {CommonLocaleManagerInstance} from "@amzn/dolphin-uiweb-framework";

export const getLocale = () => {
    const locale = DataHandler.getUserLocale();
    switch (locale) {
        case "de":
        case "de-CH":
        case "de-AT":
        case "de-LU":
        case "de-LI":
            return "de"
        case "es":
        case "es-AR":
        case "es-GT":
        case "es-CR":
        case "es-PA":
        case "es-DO":
        case "es-MX":
        case "es-VE":
        case "es-CO":
        case "es-PE":
        case "es-EC":
        case "es-CL":
        case "es-UY":
        case "es-PY":
        case "es-BO":
        case "es-SV":
        case "es-HN":
        case "es-NI":
        case "es-PR":
            return "es"
        case "fr":
        case "fr-BE":
        case "fr-CA":
        case "fr-CH":
        case "fr-LU":
            return "fr"
        case "hi":
        case "hi-IN":
            return "hi"
        case "it":
        case "it-CH":
            return "it"
        case "ja":
        case "jp":
            return "ja"
        case "pt":
        case "pt-BR":
        case "pt-PT":
            return "pt"
        case "ro":
        case "ro-RO":
            return "ro"
        case "nl":
        case "nl-NL":
        case "nl-BE":
            return "nl"
        case "tr":
        case "tr-TR":
            return "tr"
        case "ar":
        case "ar-SA":
        case "ar-IQ":
        case "ar-EG":
        case "ar-LY":
        case "ar-DZ":
        case "ar-MA":
        case "ar-TN":
        case "ar-OM":
        case "ar-YE":
        case "ar-SY":
        case "ar-JO":
        case "ar-LB":
        case "ar-KW":
        case "ar-AE":
        case "ar-BH":
        case "ar-QA":
            return "ar"
        default:
            return "en"
    }
}

export const getDirection = () => {
    return getLocale() === "ar" ? "rtl" : "ltr";
}

export const getMessages = () => {
    const locale = getLocale();
    let messages;
    switch (locale) {
        case "de":
            messages = intlMessageDE;
            break;
        case "en":
            messages = intlMessageEN;
            break;
        case "es":
            messages = intlMessageES;
            break;
        case "fr":
            messages = intlMessageFR;
            break;
        case "hi":
            messages = intlMessageHI;
            break;
        case "it":
            messages = intlMessageIT;
            break;
        case "ja":
            messages = intlMessageJP;
            break;
        case "pt":
            messages = intlMessagePT;
            break;
        case "ro":
            messages = intlMessageRO;
            break;
        case "ar":
            messages = intlMessageAR;
            break;
        case "nl":
            messages = intlMessageNL;
            break;
        case "tr":
            messages = intlMessageTR;
            break;
        default:
            messages = intlMessageEN;
    }
    return {...CommonLocaleManagerInstance.getMessages(), ...messages}
}
